import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['Correlation'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getCorrelationGetSingleAggregatedCorrelationsCoefficients: build.query<
        GetCorrelationGetSingleAggregatedCorrelationsCoefficientsApiResponse,
        GetCorrelationGetSingleAggregatedCorrelationsCoefficientsApiArg
      >({
        query: (queryArg) => ({
          url: `/Correlation/get-single-aggregated-correlations-coefficients`,
          params: {
            correlationJobId: queryArg,
          },
        }),
        providesTags: ['Correlation'],
      }),
      getCorrelationGetAggregatedCorrelationsCoefficientCounts: build.query<
        GetCorrelationGetAggregatedCorrelationsCoefficientCountsApiResponse,
        GetCorrelationGetAggregatedCorrelationsCoefficientCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/Correlation/get-aggregated-correlations-coefficient-counts`,
          params: {
            correlationJobId: queryArg,
          },
        }),
        providesTags: ['Correlation'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as correlationApi };
export type GetCorrelationGetSingleAggregatedCorrelationsCoefficientsApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesCorrelationTypesCorrelation[];
export type GetCorrelationGetSingleAggregatedCorrelationsCoefficientsApiArg = number | undefined;
export type GetCorrelationGetAggregatedCorrelationsCoefficientCountsApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesCorrelationTypesCorrelationCount[];
export type GetCorrelationGetAggregatedCorrelationsCoefficientCountsApiArg = number | undefined;
export type ApiApplicationServicesDataTypesCorrelationTypesCorrelation = {
  measurementDevice1Id?: number;
  measurementDevice2Id?: number;
  value?: number | null;
};
export type ApiApplicationServicesDataTypesCorrelationTypesCorrelationCount = {
  measurementDevice1Id?: number;
  measurementDevice2Id?: number;
  correlatingMeasurementParameters?: string[] | null;
};
export const {
  useGetCorrelationGetSingleAggregatedCorrelationsCoefficientsQuery,
  useLazyGetCorrelationGetSingleAggregatedCorrelationsCoefficientsQuery,
  useGetCorrelationGetAggregatedCorrelationsCoefficientCountsQuery,
  useLazyGetCorrelationGetAggregatedCorrelationsCoefficientCountsQuery,
} = injectedRtkApi;
